import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-adminuser',
  templateUrl: './adminuser.component.html',
  styleUrls: ['./adminuser.component.css']
})
export class AdminUserComponent implements OnInit {
@Input() tutor:any;
@Input() moduledisplay:boolean=false;
@Input() showbuttons:boolean;
@Output() manageuser:EventEmitter<any>= new EventEmitter();

  fullname:string;
  email: string;
  moduleInfo: any;
  tutorList: any;
  isFetchingData: boolean;
  confirmUserDelete:boolean=false;
  userimageurl:any;
  constructor(public useraccessservice: UseraccessserviceService, public headerinfo: ComponentheaderService, private router: Router, private activatedroute: ActivatedRoute, public modulemanager: ModulemanagementService, private toastr: ToastrService,private user:UseraccessserviceService) { }

  async ngOnInit() {
    console.log('tutor', this.tutor);
    // var userprofile= await this.user.getuserprofile(this.tutor.uid).toPromise();
    // if(userprofile.name)
    // {
    //   this.fullname=userprofile.name;
    // }
    this.fullname = this.tutor.fullName;
    this.email = this.tutor.email;
    
    await this.settutorimage();
  }
  async settutorimage() {
    this.userimageurl= (await this.useraccessservice.getuserprofileimage(this.tutor.uid).toPromise()).url;
  }

  popconfirmdelete(show:number)
  {
    if(show==1)
    {
      this.confirmUserDelete=true;
    }
    else if(show==0)
    {
      this.confirmUserDelete=false;
    }
  }

  manageuserclicked(email:string, manageaction:any)
  {
    //console.log(email,manageaction);
    this.manageuser.emit({email,manageaction});
  }

  // manageUser(id: number, usernameToManage: string, action: string) {

  //   this.isFetchingData = true;
  //   this.modulemanager.manageUser(id, usernameToManage, action).subscribe(
  //     (data: any) => {
  //       debugger;
  //       this.tutorList = data.tutors;
  //       //this.users = data.schoolUsers;
  //       this.isFetchingData = false;
  //       //this.addAdminError = null;
  //     },
  //     (err: HttpErrorResponse) => {
  //       if (err.status === 0) {
  //         this.toastr.error("Unable to connect to server");
  //       }
  //       else if (err.status === 400) {
  //         this.toastr.error(err.error.message);
  //       }
  //       this.isFetchingData = false;
  //     }
  //   );

  // }

}
